<template>
  <pay-popup
    class="recharge-wrapper"
    :class="layoutClass"
    v-model="show"
    @close="onClose"
    :couponPayPrice="couponPayPrice"
    :isFirstPay="isFirstPay"
    :walletBalance="walletBalance"
  >
    <sku-list
      class="card-item-detail"
      :class="region"
      :skuList="dataBySku"
      :activeSku="activeSku"
      @selectPackage="selectPackage"
    />
    <fold-switch
      :datas="skuList"
      :index="foldIndex.skuIndex"
      :show="show"
      @fold-switch="foldSwitchBySku"
    />
    <div class="divider"></div>

    <!-- 支付方式 -->
    <PaymentList
      :channelList="dataByPayment"
      @selectPayment="selectPayment"
      class="payment-list-detail"
    />
    <fold-switch
      :datas="channelList"
      :index="foldIndex.paymentIndex"
      :show="show"
      @fold-switch="foldSwitchByPayment"
    />
    <!-- 仅在账户正常的状态下显示支付栏 -->
    <submit-btn
      v-if="accountStatus === 1"
      :payPrice="totalAmount"
      :readyToSubmit="readyToSubmit"
      :isLoading="isCreatingOrder"
      :originalPrice="maxChannelPrice"
      @submit="gotoPay"
      :closeRecharge="closeRecharge"
    />
  </pay-popup>
</template>
<script>
  import { mapState } from 'vuex'
  import PayPopup from './PayPopup'
  import FoldSwitch from './FoldSwitch'
  import SkuList from '@/pages/Wallet/components/Sku/index'
  import PaymentList from '@/pages/Wallet/components/Payment/index'
  import SubmitBtn from '@/pages/Wallet/components/SubmitBtn'
  import walletMixins from '@/mixins/wallet/index'
  import { walletRechargePopup } from '@/pages/Detail/firebase.js'

  export default {
    name: 'wallet-recharge',
    mixins: [walletMixins],
    components: {
      PayPopup,
      SkuList,
      PaymentList,
      SubmitBtn,
      FoldSwitch,
    },
    props: [
      'value',
      'isFirstPay',
      'walletBalance',
      'couponPayPrice',
      'closeRecharge',
    ],
    data() {
      return {
        show: this.value,
        dataBySku: [],
        dataByPayment: [],
      }
    },
    computed: {
      ...mapState([
        'isDesktop',
        'isTurbo',
        'region',
        'selectedSkuInfo',
        'gameName',
      ]),
      layoutClass() {
        return this.isDesktop ? 'pc' : this.isTurbo ? 'gt' : 'h5'
      },
      foldIndex() {
        // 索引截止位置，从0开始计数
        return { skuIndex: this.region === 'id' ? 3 : 5, paymentIndex: 3 }
      },
    },
    watch: {
      value(val) {
        this.show = val
        if (val) {
          walletRechargePopup(this.gameName, 'recharge_kgold')
        }
      },
    },
    mounted() {
      // 初始化套餐、支付、服务
      this.initPackage()
    },
    methods: {
      foldSwitchBySku(data) {
        this.dataBySku = data
      },
      foldSwitchByPayment(data) {
        this.dataByPayment = data
      },
      onClose() {
        // 关闭弹窗
        this.$emit('input', false)
      },
    },
  }
</script>
<style scoped lang="scss" src="./Recharge.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './Recharge_pc.scss';
  }
</style>
